import bindAll from 'lodash.bindall';
import React from 'react';

import {connect} from 'react-redux';
import {defineMessages, intlShape, injectIntl} from 'react-intl';

import SpriteInfo from './sprite-info.jsx';
import {getHomeworkInfo} from '../lib/homework-info';

class FooterInfoBar extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleChangeSpriteDirection',
            'handleChangeSpriteName',
            'handleChangeSpriteRotationStyle',
            'handleChangeSpriteSize',
            'handleChangeSpriteVisibility',
            'handleChangeSpriteX',
            'handleChangeSpriteY'
        ]);
    }

    getSpriteInfo (txt) {
        const homeworkInfo = getHomeworkInfo();
        const courseId = Number(homeworkInfo.courseId);
        const unitId = Number(homeworkInfo.unitId);
        const lessonId = Number(homeworkInfo.lessonId);
        const editingTarget = this.props.vm.editingTarget;
        const id = editingTarget.id;
        const name = editingTarget.sprite.name;
        ht.track(`s3_stage_sprite_${txt}`, {
            context: {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                stageDisplayMode: localStorage.getItem('stageDisplayMode')
            },
            param: {
                sprite: {
                    id: id,
                    name: name
                }
            }
        });
    }
    handleChangeSpriteDirection (direction) {
        this.getSpriteInfo('direction');
        this.props.vm.postSpriteInfo({direction});
    }
    handleChangeSpriteName (name) {
        this.props.vm.renameSprite(this.props.editingTarget, name);
    }
    handleChangeSpriteSize (size) {
        this.getSpriteInfo('size');
        this.props.vm.postSpriteInfo({size});
    }
    handleChangeSpriteVisibility (visible) {
        this.getSpriteInfo('visibility');
        this.props.vm.postSpriteInfo({visible});
    }
    handleChangeSpriteX (x) {
        this.getSpriteInfo('x');
        this.props.vm.postSpriteInfo({x});
    }
    handleChangeSpriteY (y) {
        this.getSpriteInfo('y');
        this.props.vm.postSpriteInfo({y});
    }
    handleChangeSpriteRotationStyle (rotationStyle) {
        this.props.vm.postSpriteInfo({rotationStyle});
    }
    render () {
        let selectedSprite = this.props.sprites[this.props.editingTarget];
        const selectedStage = this.props.stage.id === this.props.editingTarget ? this.props.stage : null;
        let spriteInfoDisabled = false;
        if (typeof selectedSprite === 'undefined') {
            selectedSprite = {};
            spriteInfoDisabled = true;
        }
        if (selectedStage) {
            selectedSprite = {
                visible: true
            };
            spriteInfoDisabled = true;
        }
        const messages = defineMessages({
            stage: {
                defaultMessage: 'Stage',
                description: 'Label for the stage in the stage selector',
                id: 'gui.stageSelector.stage'
            }
        });
        const name = selectedStage ? (this.props.intl.formatMessage(messages.stage)) : selectedSprite.name;
        return (
            <SpriteInfo
                direction={selectedSprite.direction}
                disabled={spriteInfoDisabled}
                name={name}
                rotationStyle={selectedSprite.rotationStyle}
                size={selectedSprite.size}
                stageSize={this.props.stageSize}
                visible={selectedSprite.visible}
                x={selectedSprite.x}
                y={selectedSprite.y}
                onChangeDirection={this.handleChangeSpriteDirection}
                onChangeName={this.handleChangeSpriteName}
                onChangeSize={this.handleChangeSpriteSize}
                onChangeSpriteRotationStyle={this.handleChangeSpriteRotationStyle}
                onChangeVisibility={this.handleChangeSpriteVisibility}
                onChangeX={this.handleChangeSpriteX}
                onChangeY={this.handleChangeSpriteY}
            />
        );
    }
}

const {
    ...spriteInfoProps
} = SpriteInfo.propTypes;

FooterInfoBar.propTypes = {
    ...spriteInfoProps,
    intl: intlShape.isRequired
};

const mapStateToProps = state => ({
    editingTarget: state.scratchGui.targets.editingTarget,
    sprites: Object.keys(state.scratchGui.targets.sprites).reduce((sprites, k) => {
        let {direction, size, x, y, ...sprite} = state.scratchGui.targets.sprites[k];
        if (typeof direction !== 'undefined') direction = Math.round(direction);
        if (typeof x !== 'undefined') x = Math.round(x);
        if (typeof y !== 'undefined') y = Math.round(y);
        if (typeof size !== 'undefined') size = Math.round(size);
        sprites[k] = {...sprite, direction, size, x, y};
        return sprites;
    }, {}),
    stage: state.scratchGui.targets.stage
});

export default injectIntl(connect(
    mapStateToProps
)(FooterInfoBar));
